export const checkHtml = (_html?: string) => {
  if (_html) return _html;
  return '';
};
